import React from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { formatOcCodeLabel, sanitizePublicCandidate } from '../../utils/ocRequest';

/**
 * Candidate table for internal or public (decisions) use.
 *
 * Internal Notes show the lab-only `review_notes`. Public rows show
 * `discrepancies` only — the client serializer omits review and internal notes.
 */
const OcCandidateTable = ({
  candidates = [],
  mode = 'internal',
  decisions = {},
  onDecisionChange,
  onDelete,
  deletingId,
}) => {
  if (!candidates.length) {
    return <p className="text-muted">No candidates yet.</p>;
  }

  return (
    <div className="oc-table-wrap">
    <Table striped bordered hover responsive size="sm" className="mb-0">
      <thead>
        <tr>
          <th>OC ID</th>
          <th>Match</th>
          <th>Notes</th>
          {mode === 'internal' ? (
            <>
              <th>Data mgr</th>
              <th>Tech</th>
              <th>Client</th>
              <th />
            </>
          ) : (
            <th>Your decision</th>
          )}
        </tr>
      </thead>
      <tbody>
        {candidates.map(raw => {
          const c = mode === 'public' ? sanitizePublicCandidate(raw) : raw;
          const rowId = c.id;
          return (
            <tr key={rowId}>
              <td>
                {c.display_oc_id || c.free_text_oc_id || c.organoid_culture?.oc_id || '—'}
              </td>
              <td>{formatOcCodeLabel(c.match_type)}</td>
              <td>
                {mode === 'public'
                  ? c.discrepancies || '—'
                  : c.review_notes || c.internal_notes || c.discrepancies || '—'}
              </td>
              {mode === 'internal' ? (
                <>
                  <td>{c.isDraft ? '—' : formatOcCodeLabel(c.data_manager_decision)}</td>
                  <td>{c.isDraft ? '—' : formatOcCodeLabel(c.technical_decision)}</td>
                  <td>{c.isDraft ? '—' : formatOcCodeLabel(c.client_decision)}</td>
                  <td>
                    {onDelete ? (
                      <Button
                        size="sm"
                        variant="outline-danger"
                        disabled={deletingId === rowId}
                        onClick={() => onDelete(rowId)}
                      >
                        Remove
                      </Button>
                    ) : null}
                  </td>
                </>
              ) : (
                <td>
                  <Form.Select
                    size="sm"
                    value={decisions[c.id] || c.client_decision || ''}
                    onChange={e => onDecisionChange?.(c.id, e.target.value)}
                  >
                    <option value="">— Select —</option>
                    <option value="accepted">Accept</option>
                    <option value="rejected">Decline</option>
                  </Form.Select>
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </Table>
    </div>
  );
};

export default OcCandidateTable;
